const store = createStore({
  state: {
    idData: '',
    env_variables : {},
    path_variables: {},
    process_states: {},
    gene_name_loc: {},
    activeBiomarker: {},
    app_values: {},
    variants: {},
    snvs: {},
    ins: {},
    dels: {},
    indels: {},
    cnvs: {},
    fusions: {},
    genes: {},
    unidentified: {},
    active_annot: 1,
    id_list: {},
    mtb_data: {},
    tumor_types: [],
    selected_tumor_type: '',
    active_snv_columns : [],
    active_id_data: {},
    id_variants: {},
    id_snvs: {},
    id_ins: {},
    id_dels: {},
    id_cnvs: {},
    id_fusions: {},
    id_unidentified: {},
    oncokb_key: '',
    active_transcript: {},
    active_protein: '',
    show_snv_plots: true,
    show_gene_plots: false,
    metadata: {},
    csv_download: '',
    pdf_download: '',
    devmode: false,
    results_loaded: false,
    last_onkopus_query: '',
    annotated_modules: [],
    current_mtb: 'mtb-1',
    request_id: '',
    isLoading: false,

    ag_grid_coldefs: {},
    ag_grid_rowdata: {},
    ag_grid_rowkeys: {},
    ag_grid_shown: {},
    
    presentation_mode: 'all',
    presentation_selected_variants: {},
    presentation_device_id: '',
    presentation_slide: "0",
    presentation_registered_devices: {},
    presentation_selected_patients: {},
    presentation_all_patients: {},
    presentation_current_patient: '',
    presentation_flipstate: {flipstate: false, flip: 'none'},
    presentation_config: {
      nextPatientOnCarousel: false,
      firstPageOnSwitch: false,
    },
    presentation_slides: {
      "0": {id: 'patient_data',title: 'Patient Data', icon: 'mdi-account-details', index: 0,},
      "1": {id: 'variants',title: 'Variants', icon: 'mdi-dna', index: 1,},
      "2": {id: 'interpretation',title: 'Interpretation', icon: 'mdi-medical-bag', index: 2,},
      "3": {id: 'recommendations',title: 'Recommendations', icon: 'mdi-pill', index: 3,},
    },
  },
  mutations: {
    set_is_loading: (state, newValue) => {
        state.isLoading = newValue
    },
    set_idData: (state, newValue) => {
      state.idData = newValue
    },
    set_file: (state, newValue) => {
      state.file = newValue
    },
    set_active_biomarker: (state, newValue) => {
      state.activeBiomarker = newValue
    },
    set_query: (state, newValue) => {
      state.query = newValue
    },
    set_router_base_url: (state, newValue) => {
      state.routerBaseUrl = newValue
    },
    set_env_variable: (state, newValue ) => {
      state.env_variables[newValue[0]] = newValue[1]
    },
    set_path_variable: (state, newValue ) => {
      state.path_variables[newValue[0]] = newValue[1]
    },
    set_gene_name_loc: (state, newValue ) => {
      state.gene_name_loc[newValue[0]] = newValue[1]
    },
    set_app_value:(state, newValue ) => {
      state.app_values[newValue[0]] = newValue[1]
    },
    set_current_mtb: (state, mtb) => {
      state.current_mtb = mtb;
    },
    set_variants: (state, newValue) => {
      state.variants = newValue
    },
    set_snvs: (state, newValue) => {
      state.snvs = newValue
    },
    set_ins: (state, newValue) => {
      state.ins = newValue
    },
    set_dels: (state, newValue) => {
      state.dels = newValue
    },
    set_indels: (state, newValue) => {
      state.indels = newValue
    },
    set_cnvs: (state, newValue) => {
      state.cnvs = newValue
    },
    set_fusions: (state, newValue) => {
      state.fusions = newValue
    },
    set_genes: (state, newValue) => {
      state.genes = newValue
    },
    set_unidentified: (state, newValue) => {
      state.unidentified = newValue
    },
    set_genome_version: (state, newValue) => {
      state.genomeVersion = newValue
    },
    set_process_state: (state, newValue) => {
      state.process_states[newValue[0]] = newValue[1]
    },
    set_back_ref: (state, newValue) => {
      state.backRef = newValue
    },
    set_active_annot: (state, newValue) => {
      state.active_annot = newValue
    },
    set_id_list: (state, newValue) => {
      state.id_list = newValue
    },
    set_mtb_data: (state, newValue) => {
      state.mtb_data = newValue
    },
    set_tumor_types: (state, newValue) => {
      state.tumor_types = newValue
    },
    set_selected_tumor_type: (state, newValue) => {
      state.selected_tumor_type = newValue
    },
    set_active_snv_columns: (state, newValue) => {
      state.active_snv_columns = newValue
    },
    set_active_id_data: (state, newValue) => {
      state.active_id_data = newValue
    },
    set_id_variants: (state, newValue) => {
      state.id_variants = newValue
    },
    set_id_snvs: (state, newValue) => {
      state.id_snvs = newValue
    },
    set_id_ins: (state, newValue) => {
      state.id_ins = newValue
    },
    set_id_dels: (state, newValue) => {
      state.id_dels = newValue
    },
    set_id_cnvs: (state, newValue) => {
      state.id_cnvs = newValue
    },
    set_id_fusions: (state, newValue) => {
      state.id_fusions = newValue
    },
    set_id_unidentified: (state, newValue) => {
      state.id_unidentified = newValue
    },
    set_oncokb_key: (state, newValue) => {
      state.oncokb_key = newValue
    },
    set_show_snv_plots: (state, newValue) => {
      state.show_snv_plots = newValue
    },
    set_ag_grid_coldefs: (state, payload) => {
      state.ag_grid_coldefs[payload.id] = payload.defs;
    },
    set_ag_grid_rowdata: (state, payload) => {
      state.ag_grid_rowdata[payload.id] = payload.data;
    },
    set_ag_grid_rowkeys: (state, payload) => {
      state.ag_grid_rowkeys[payload.id] = payload.keys;
    },
    set_ag_grid_shown: (state, payload) => {
      if (payload.table_id == '$all') {
        for (let table in Object.keys(state.ag_grid_shown)) {
          state.ag_grid_shown[table] = payload.show_grid;
        }
      } else {
        state.ag_grid_shown[payload.table_id] = payload.show_grid;
      }
    },
    clear_ag_grid_data: (state) => {
      var rd_keys = Object.keys(state.ag_grid_rowdata);
      for (var k of rd_keys) {
        delete state.ag_grid_rowdata[k]
      }
      var rk_keys = Object.keys(state.ag_grid_rowkeys);
      for (var k of rk_keys) {
        console.log(k)
        delete state.ag_grid_rowkeys[k]
        console.log(state.ag_grid_rowkeys);
      }
      var cd_keys = Object.keys(state.ag_grid_coldefs);
      for (var k of cd_keys) {
        delete state.ag_grid_coldefs[k]
      }
      console.log(state.ag_grid_rowkeys);
    },
    clear_presentation_selected_patients: (state) => {
      for (let sp in state.presentation_selected_patients) delete state.presentation_selected_patients[sp];
    },
    toggle_presentation_patient_selected: (state, patient) => {
      if (patient.id in state.presentation_selected_patients) delete state.presentation_selected_patients[patient.id]
      else
        state.presentation_selected_patients[patient.id] = patient;
    },
    set_presentation_patient: (state, patient_id) => {
      state.presentation_current_patient = patient_id;
    },
    set_presentation_all_patients: (state, patients) => {
      state.presentation_all_patients = patients;
    },
    set_presentation_config_np: (state, config_setting) => {
      state.presentation_config.nextPatientOnCarousel = config_setting;
    },
    set_presentation_config_fp: (state, config_setting) => {
      state.presentation_config.firstPageOnSwitch = config_setting;
    },
    toggle_presentation_variant_selected: (state, id) => {
      if (Object.keys(state.presentation_selected_variants).includes(id))
        delete state.presentation_selected_variants[id];
      else
        state.presentation_selected_variants[id] = id;
    },
    set_presentation_mode: (state, mode) => {
      state.presentation_mode = mode;
    },
    set_presentation_registered_devices: (state, list_of_devices) => {
      state.presentation_registered_devices = list_of_devices;
    },
    set_presentation_device_id: (state, device_id) => {
      state.presentation_device_id = device_id;
    },
    set_presentation_slide: (state, slide) => {
      state.presentation_slide = slide.toString();
    },
    set_annotated_modules: (state, newValue) => {
      state.annotated_modules = newValue
    },
    perform_presentation_flip_forward: (state, flipstate) => {
      state.presentation_flipstate = {flip: 'forward', flipstate: flipstate};
    },
    perform_presentation_flip_backward: (state, flipstate) => {
      state.presentation_flipstate = {flip: 'backward', flipstate: flipstate};
    },
    set_onkopus_metadata: (state, metadata) => {
      state.metadata = metadata;
    },
    clear_onkopus_metadata: (state) => {
      state.metadata = {};
    },
    set_devmode: (state, flag) => {
      if (flag && flag.toLowerCase() == 'true') state.devmode = true;
      else { state.devmode = false;}
    },
    set_results_loaded: (state, newValue) => {
        state.results_loaded = newValue
    },
    set_onkopus_last_query: (state, query_string) => {
      state.last_query = query_string;
    },
    set_active_transcript: (state, newValue) => {
      state.active_transcript = newValue
    },
    set_active_protein: (state, newValue) => {
      state.active_protein = newValue
    },
    set_request_id: (state, newValue) => {
      state.request_id = newValue
    },
  },
  getters: {
    isLoading (state) {
        return state.isLoading
    },
    getEnvVariable: (state) => (id) => {
      return state.env_variables[id]
    },
    getPathVariable: (state) => (id) => {
      return state.path_variables[id]
    },
    getGeneNameLoc: (state) => (id) => {
      return state.gene_name_loc[id]
    },
    getGeneNameLocAll (state) {
      return state.gene_name_loc
    },
    getAppValue: (state) => (id) => {
      return state.app_values[id]
    },
    getIDData (state) {
      return state.idData
    },
    getActiveBiomarker (state) {
      return state.activeBiomarker
    },
    getFile (state) {
      return state.file
    },
    getRouterBaseURL (state) {
      return state.routerBaseUrl
    },
    getVariants (state) {
      return state.variants
    },
    snvs (state) {
      return state.snvs
    },
    ins (state) {
      return state.ins
    },
    dels (state) {
      return state.dels
    },
    indels (state) {
      return state.indels
    },
    cnvs (state) {
      return state.cnvs
    },
    fusions (state) {
      return state.fusions
    },
    genes (state) {
      return state.genes
    },
    unidentified (state) {
      return state.unidentified
    },
    doneTodos (state) {
      return state.todos.filter(todo => todo.done)
    },
    doneTodosCount (state, getters) {
      return getters.doneTodos.length
    },
    getGenomeVersion(state) {
      return state.genomeVersion
    },
    getProcessState: (state) => (id) => {
        return state.process_states[id]
    },
    query (state) {
      return state.query
    },
    backRef (state) {
      return state.backRef
    },
    activeAnnot (state) {
      return state.active_annot
    },
    idList (state) {
      if (!state.id_list || !Object.keys(state.id_list).length) return;
      //Turn IDs into strings so they can actually be used
      Object.keys(state.id_list?.patients).map(key => {
        delete state.id_list.patients[key]['id'];
        state.id_list.patients[key]['id'] = String(key);
      })
      return state.id_list?.patients
    },
    mtbData (state) {
      return state.mtb_data
    },
    tumorTypes (state) {
      return state.tumor_types
    },
    selectedTumorType (state) {
      return state.selected_tumor_type
    },
    activeSNVColumns (state) {
      return state.active_snv_columns
    },
    activeIdData (state) {
      return state.active_id_data
    },
    id_variants (state) {
      return state.id_variants
    },
    id_snvs (state) {
      return state.id_snvs
    },
    id_ins (state) {
      return state.id_ins
    },
    id_dels (state) {
      return state.id_dels
    },
    id_cnvs (state) {
      return state.id_cnvs
    },
    id_fusions (state) {
      return state.id_fusions
    },
    id_unidentified (state) {
      return state.id_unidentified
    },
    oncokbKey (state) {
      return state.oncokb_key
    },
    showSNVPlots (state) {
      return state.show_snv_plots
    },
    presentation_getconfig (state) {
      return state.presentation_config;
    },
    presentation_getpatientlist (state) {
      if (Object.keys(state.presentation_all_patients).length == 0) return null;
      if (state.presentation_mode == 'selected' && Object.keys(state.presentation_selected_patients).length > 0) return state.presentation_selected_patients;
      else return state.presentation_all_patients;
    },
    presentation_getpagetitle (state) {
      return state.presentation_slides[state.presentation_slide.toString()].title; 
    },
    presentation_getpageindex: (state) => (title) => {
      for (var i in state.presentation_slides) {
        if (title == state.presentation_slides[i].title) return state.presentation_slides[i].index;
      }
      return 0;
    },
    ag_grid_getrowdata (state) {
      return state.ag_grid_rowdata;
    },
    ag_grid_getrowkeys (state) {
      return state.ag_grid_rowkeys;
    },
    ag_grid_getshown: (state) => (table_id) => {
      return state.ag_grid_shown[table_id] ? state.ag_grid_shown[table_id] : false;
    },
    annotatedModules (state) {
      return state.annotated_modules
    },
    biomarkersForCurrentPatient (state) {
      if (!state.presentation_current_patient || !Object.keys(state.id_list).length) return {};
      return state.id_list.patients[state.presentation_current_patient.id];
    },
    get_metadata_for: (state) => (term) => {
      if (Object.keys(state.metadata).includes(term.toLowerCase())) {
        return state.metadata[term.toLowerCase()];
      }
      else
        return state.metadata['default'];
    },
    resultsLoaded (state) {
        return state.results_loaded
    },
    get_devmode: (state) => {
      return state.devmode;
    },
    activeTranscript (state) {
      return state.active_transcript
    },
    activeProtein (state) {
      return state.active_protein
    },
    requestID (state) {
      return state.request_id
    },
  },
  actions: {
    setIsLoading: ({ commit, state }, newValue) => {
          commit('set_is_loading', newValue)
          return state.isLoading
    },
    setEnvVariable: ({ commit, state }, newValue ) => {
      commit('set_env_variable', newValue )
      return state.env_variables
    },
    setFile: ({ commit, state }, newValue) => {
      commit('set_file', newValue )
      return state.file
    },
    setActiveBiomarker: ({ commit, state }, newValue) => {
      commit('set_active_biomarker', newValue )
      return state.activeBiomarker
    },
    setQuery: ({ commit, state }, newValue) => {
      commit('set_query', newValue)
      return state.idData
    },
    setPathVariable: ({ commit, state }, newValue ) => {
      commit('set_path_variable', newValue )
      return state.path_variables
    },
    setGeneNameLoc: ({ commit, state }, newValue ) => {
      commit('set_gene_name_loc', newValue )
      return state.getGeneNameLoc
    },
    setAppValue: ({ commit, state }, newValue ) => {
      commit('set_app_value', newValue )
      return state.app_values
    },
    setIdData: ({ commit, state }, newValue) => {
      commit('set_idData', newValue)
      return state.idData
    },
    setRouterBaseUrl: ({ commit, state}, newValue) => {
        commit('set_router_base_url', newValue)
        return state.routerBaseUrl
    },
    setVariants: ({ commit, state }, newValue) => {
      commit('set_variants', newValue)
      return state.variants
    },
    setSNVs: ({ commit, state }, newValue) => {
      commit('set_snvs', newValue)
      return state.snvs
    },
    setIns: ({ commit, state }, newValue) => {
      commit('set_ins', newValue)
      return state.ins
    },
    setDels: ({ commit, state }, newValue) => {
      commit('set_dels', newValue)
      return state.dels
    },
    setInDels: ({ commit, state }, newValue) => {
      commit('set_indels', newValue)
      return state.indels
    },
    setCNVs: ({ commit, state }, newValue) => {
      commit('set_cnvs', newValue)
      return state.cnvs
    },
    setFusions: ({ commit, state }, newValue) => {
      commit('set_fusions', newValue)
      return state.fusions
    },
    setGenes: ({ commit, state }, newValue) => {
      commit('set_genes', newValue)
      return state.genes
    },
    setUnidentified: ({ commit, state }, newValue) => {
      commit('set_unidentified', newValue)
      return state.unidentified
    },
    setGenomeVersion: ({ commit, state }, newValue) => {
      commit('set_genome_version', newValue)
      return state.genomeVersion
    },
    setProcessState: ({ commit, state }, newValue ) => {
      commit('set_process_state', newValue )
      return state.process_states
    },
    setBackRef: ({ commit, state }, newValue) => {
      commit('set_back_ref', newValue)
      return state.backRef
    },
    setActiveAnnot: ({ commit, state }, newValue) => {
      commit('set_active_annot', newValue)
      return state.active_annot
    },
    setIDList: ({ commit, state }, newValue) => {
      commit('set_id_list', newValue)
      return state.id_list
    },
    setMTBData: ({ commit, state }, newValue) => {
      commit('set_mtb_data', newValue)
      return state.mtb_data
    },
    setTumorTypes:  ({ commit, state }, newValue) => {
      commit('set_tumor_types', newValue)
      return state.tumor_types
    },
    setSelectedTumorType: ({ commit, state }, newValue) => {
      commit('set_selected_tumor_type', newValue)
      return state.selected_tumor_type
    },
    setActiveSNVColumns: ({ commit, state }, newValue) => {
      commit('set_active_snv_columns', newValue)
      return state.active_snv_columns
    },
    setActiveIdData: ({ commit, state }, newValue) => {
      commit('set_active_id_data', newValue)
      return state.active_id_data
    },
    setShowSNVPlots: ({ commit, state }, show_plots) => {
      commit('set_show_snv_plots', show_plots)
      return state.show_snv_plots;
    },
    setIdVariants: ({ commit, state }, newValue) => {
      commit('set_id_variants', newValue)
      return state.id_variants
    },
    setIdSNVs: ({ commit, state }, newValue) => {
      commit('set_id_snvs', newValue)
      return state.id_snvs
    },
    setIdIns: ({ commit, state }, newValue) => {
      commit('set_id_ins', newValue)
      return state.id_ins
    },
    setIdDels: ({ commit, state }, newValue) => {
      commit('set_id_dels', newValue)
      return state.id_dels
    },
    setIdCNVs: ({ commit, state }, newValue) => {
      commit('set_id_cnvs', newValue)
      return state.id_cnvs
    },
    setIdFusions: ({ commit, state }, newValue) => {
      commit('set_id_fusions', newValue)
      return state.id_fusions
    },
    setIdUnidentified: ({ commit, state }, newValue) => {
      commit('set_id_unidentified', newValue)
      return state.id_unidentified
    },
    setAnnotatedModules: ({ commit, state }, newValue) => {
      commit('set_annotated_modules', newValue)
      return state.annotated_modules
    },
    setCurrentMTB: ({ commit, state }, mtb) => {
      commit('set_current_mtb', mtb);
      return state.current_mtb;
    },
    setOncoKBKey: ({ commit, state }, key) => {
      commit('set_oncokb_key', key);
      return state.oncokb_key;
    },
    setActiveTranscript: ({ commit, state }, newValue) => {
      commit('set_active_transcript', newValue)
      return state.active_transcript
    },
    setActiveProtein: ({ commit, state }, newValue) => {
      commit('set_active_protein', newValue)
      return state.active_protein
    },

    /* ############################## Actions for Presentation Mode ############################## */

    /* Stores all patients for a MTB presentation. */
    setPresentationAllPatients: ({ commit, state }, patients) => {
      commit('set_presentation_all_patients', patients);
      return state.presentation_all_patients;
    },

    /* Sets the currently selected/shown patient for the MTB presentation. Takes a patient object with all data included. */
    setPresentationPatient: ({ commit, state }, patient) => {
      commit('set_presentation_patient', patient);
      return state.presentation_current_patient;
    },

    /* Sets the currently selected patient (for the presentation) based on a list index */
    setPresentationPatientByIndex: ({commit, getters, state}, payload) => {

      // Get correct patient list (all patients/only selected), get index of current patient
      let patient_list = getters.presentation_getpatientlist;
      if (patient_list === null) return;
      if (!payload.patient_index)
        payload.patient_index = state.presentation_current_patient ? Object.keys(patient_list).indexOf(state.presentation_current_patient.id.toString()) : 0;

      // Calculate new index
      payload.patient_index += payload.offset;
      if (payload.patient_index <= -1) payload.patient_index = Object.keys(patient_list).length -1;
      if (payload.patient_index >= Object.keys(patient_list).length) payload.patient_index = 0;

      //Commit to store
      commit('set_presentation_patient', patient_list[Object.keys(patient_list)[payload.patient_index]]);
    },

    /* Sets the currently selected patient (for the presentation) based on their ID */
    setPresentationPatientByID: ({commit, getters}, payload) => {

      let patient_list = getters.presentation_getpatientlist;
      if (patient_list === null) return;
      if (!Object.keys(patient_list).includes(payload.patient_id)) return;
      commit('set_presentation_patient', patient_list[payload.patient_id]);
    },

    /* Sets the slide currently shown in presentation mode (by slide index, casted to a string, e.g. "0"). */
    setPresentationSlide: ({ commit, state }, slide_title) => {
      commit('set_presentation_slide', slide_title);
      return state.presentation_slide;
    },

    /* Toggles whether a variant is selected or not. */
    togglePresentationVariantSelected: ({ commit, state}, variant) => {
      commit('toggle_presentation_variant_selected', variant);
      return state.presentation_selected_variants;
    },

    /* ############################## */

    /* Sets/updates the list of currently connected devices for presentation purposes. */
    setPresentationRegisteredDevices: ({ commit, state }, devices) => {
      commit('set_presentation_registered_devices', devices);
      return state.presentation_registered_devices;
    },

    /* Sets a device identifier for this device. The identifier is used for MTB Configuration/websocket purposes. */
    setPresentationDeviceID: ({ commit, state }, device_id) => {
      commit('set_presentation_device_id', device_id);
      return state.presentation_device_id;
    },

    /* ############################## */
    
    /* Either scrolls downwards or goes one table page forward, depending on the slide. */
    performPresentationFlipForward: ({ commit }, flip) => {
      commit('perform_presentation_flip_forward', flip);
    },

    /* Either scrolls upwards or goes one table page backwards, depending on the slide. */
    performPresentationFlipBackward: ({ commit }, flip) => {
      commit('perform_presentation_flip_backward', flip);
    },

    /* Sets the "Next Patient On Carousel" option. If it is enabled, clicking the presentation nav. arrows can also change the current patient. */
    setPresentationConfig_NP: ({ commit, state }, option) => {
      commit('set_presentation_config_np', option);
      return state.presentation_config;
    },

    /* Sets the "First Page on Patient Switch" option. If it is enabled, the presentation will always jump to the first slide if a new patient is selected. */
    setPresentationConfig_FP: ({ commit, state }, option) => {
      commit('set_presentation_config_fp', option);
      return state.presentation_config;
    },

    /* ############################## */

    /* Sets presentation mode, e.g. to "all" or "selected" (currently only one mode, "all", exists). */
    setPresentationMode: ({ commit, state }, mode) => {
      commit('set_presentation_mode', mode);
      return state.presentation_mode;
    },

    /* Toggles whether a patient is part of the 'selected patients' subset or not (currently not included in Onkopus). */
    togglePresentationPatientSelected: ({ commit, state}, patient) => {
      commit('toggle_presentation_patient_selected', patient);
      return state.presentation_selected_patients;
    },

    /* Clears the list of selected patients (currently not included in Onkopus). */
    clearPresentationSelectedPatients: ({ commit }) => {
      commit('clear_presentation_selected_patients');
    },

    /* ############################## Actions for AG Grid ############################## */

    /* Clears any existing AG Grid variables from the store. */
    clearAGG: ({ commit }) => {
      commit('clear_ag_grid_data');
    },

    /* Stores the row keys for a particular table. */
    setAGGRowkeys: ({ commit, state }, rowkeys) => {
      commit('set_ag_grid_rowkeys', rowkeys);
      return state.ag_grid_rowkeys;
    },

    /* Stores the row data (= data shown in the table) for a particular table. */
    setAGGRowdata: ({ commit, state }, rowdata) => {
      commit('set_ag_grid_rowdata', rowdata);
      return state.ag_grid_rowdata;
    },

    /* Stores the column definitions for a particular table. */
    setAGGColdefs: ({ commit, state }, coldefs) => {
      commit('set_ag_grid_coldefs', coldefs);
      return state.ag_grid_coldefs;
    },

    /* Boolean that represents whether the grid on a particular table is shown or not. */
    setAGGShown: ({commit, state}, payload) => {
      commit('set_ag_grid_shown', payload);
      return state.ag_grid_shown;
    },

    /* ############################## Purely Frontend-Related Actions ############################## */

    /* Stores Onkopus metadata (from metadata.json) in cache, so it can be accessed, e.g. for tooltips. */
    setOnkopusMetadata: ({ commit, state }, metadata) => {
      commit('set_onkopus_metadata', metadata);
      return state.metadata;
    },

    /* Clears the cached Onkopus metadata. */
    clearOnkopusMetadata: ({ commit }) => {
      commit('clear_onkopus_metadata');
    },

    /* Stores the last query string, for comparison to any new query strings (to avoid unnecessary loading). */
    setLastOnkopusQuery: ({ commit, state }, query) => {
      commit('set_onkopus_last_query', query);
      return state.last_onkopus_query;
    },

    /* Sets a flag that reflects whether devmode items should be shown or not. */
    setDevmodeFlag: ({ commit, state }, devmode_flag) => {
      commit('set_devmode', devmode_flag);
      return state.devmode;
    },

    /* Sets a flag that reflects whether results are still being loaded or the loading process is completed. */
    setResultsLoaded: ({ commit, state }, newValue) => {
      commit('set_results_loaded', newValue)
      return state.results_loaded
    },

    setRequestID: ({ commit, state }, newValue) => {
      commit('set_request_id', newValue )
      return state.request_id
    },
  }
})

import { createStore } from 'vuex'
export { store }
export default { store }

